import { ViewModel, View, ObservableArray } from "binder"
import { ToolStatusManipulationView } from "./toolStatusManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ToolStatusEditorViewModel, ToolStatusInserter, ToolStatusUpdater } from "./ToolStatusEditor/toolStatusEditor-viewModel";
import { IToolStatus } from "./IToolStatus";

export class ToolStatusManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف وضعیت ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolStatuses = ObservableArray.create<ToolStatus>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolStatusManipulationView();
    }
    public getTypeId(): string {
        return "VM-68BE9769-C651-422B-B8FE-EA7907ADBCCF"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolStatuses(v: ObservableArray<ToolStatus>) { this._toolStatuses = v; } public get toolStatuses(): ObservableArray<ToolStatus> { return this._toolStatuses; } private _toolStatuses: ObservableArray<ToolStatus>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ListAllToolStatuses', {
                FilteringInformation: filteringInformation
            });
            this.toolStatuses.update(...result.ToolStatuses.map((x, i) => {
                let t = new ToolStatus(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.ToolStatusListId;
                t.name = x.StatusName;
                t.code = x.StatusCode;
                t.force = x.Force;
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ToolStatusEditorViewModel(this, new ToolStatusInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(toolStatus: IToolStatus) {
        let popup = new ToolStatusEditorViewModel(this, new ToolStatusUpdater());
        await toolStatus.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(toolStatus: ToolStatus): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ToolStatusServices/DeleteToolStatus", {
                    ToolStatusId: toolStatus.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ToolStatus extends ViewModel implements IToolStatus {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolStatusManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolStatusManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set force(v: boolean) { this._force = v; } public get force(): boolean { return this._force; } private _force: boolean;

    async cloneTo(toolStatus: IToolStatus) {
        toolStatus.id = this.id;
        toolStatus.name = this.name;
        toolStatus.code = this.code;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
